module.exports = __webpack_public_path__ + "img/14.6aa26be3.jpg";